import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import PropTypes from 'prop-types';

export const LowInventoryFOMOmsg = props => {
  const {
    rooms,
    leadRoomOnly,
    leadRateOnly,
    hotelID,
    hotelsPriceDrop = '',
    hotelsLastRoom = '',
    lastRoomCount = 1,
    featureEnableFOMO = true,
    enableTest,
    isBanner,
    bookingDoneFomo = '',
    fastFillingFomo = '',
    roomSource,
    testLeadRate = false,
    testCheckID = false,
    useOnlyFeatureFlags = false,
  } = props;
  // eslint-disable-next-line no-shadow
  const getLeadRateID = (o, def = '') =>
    o && o[0] && o[0].rates && o[0].rates[0]
      ? `${o[0].id}-${o[0].rates[0].id}-${o[0].rates[0].rateOptionId}`
      : def;
  const leadRateID = getLeadRateID(roomSource);
  const roomRateID = getLeadRateID([rooms], '-');
  const checkLeadRate = (leadRateID, id, rateId, OptionId) =>
    leadRateID === id + '-' + rateId + '-' + OptionId ?? false;

  const getHasRateID = (leadRateID, rooms) => {
    if (!isBanner) {
      const resultArray = leadRateID.split('-');
      const rateID = resultArray[1];
      // Check if any room has an 'id' property equal to 'rateID'
      const rates = rooms.rates || [];
      let hasRateID = false;
      for (const rate of rates) {
        if (rate.id === rateID) {
          hasRateID = true;
          break; // Exit the loop early once a match is found
        }
      }
      return hasRateID;
    }
    return false;
  };

  const isLeadRate = getHasRateID(leadRateID, rooms);

  if (testLeadRate) return roomRateID;
  if (testCheckID) return isLeadRate;

  const splitHotelsFOMO = hotelsListFOMO => {
    let isHotelFOMOValid = hotelsListFOMO
      ?.split(',')
      .includes(hotelID?.toString());
    return isHotelFOMOValid;
  };

  const configLastRoom = splitHotelsFOMO(hotelsLastRoom);
  const configlastRoomCount = lastRoomCount;
  const configPriceDrop = splitHotelsFOMO(hotelsPriceDrop);
  const configBookingDoneFomo = splitHotelsFOMO(bookingDoneFomo);
  const configFastFillingFomo = splitHotelsFOMO(fastFillingFomo);

  const isDiscountGreaterTen = rate => {
    return rate.discountValue > 10;
  };

  const getMessageForRate = rate => {
    if (rate.discountValue && rate.discountValue !== null && configPriceDrop) {
      if (rate.discountValue === null) return '';
      if (rate.discountValue < 1) return '';
      if (useOnlyFeatureFlags) {
        if (!configPriceDrop) {
          return '';
        }
      }
      return isDiscountGreaterTen(rate)
        ? enableTest
          ? 'Last minute price drop and Lowest price in last x months'
          : translate('fomoMessages.lowestPriceInXMonth')
        : enableTest
        ? 'Lowest price in last 2 months'
        : translate('fomoMessages.priceDrop');
    }
    return '';
  };
  // eslint-disable-next-line no-shadow
  const getMessageForAvailable = () => {
    const fomoMsg = {
      message: '',
    };

    if ((rooms.rates && rooms.rates[0].availableRooms) || configLastRoom) {
      if (isLeadRate) {
        if (useOnlyFeatureFlags) {
          if (!configLastRoom) {
            fomoMsg.message = '';
            fomoMsg.rate = {};
            return fomoMsg;
          }
        }

        const roomsCount = rooms?.rates?.[0]?.availableRooms ?? null;
        if (roomsCount) {
          if (enableTest) {
            fomoMsg.message = 'Only ' + 7 + ' rooms available';
          } else if (roomsCount == 1) {
            fomoMsg.message = translate('fomoMessages.lastRoom');
          } else {
            fomoMsg.message = translate('roomCard.roomsLeftText', {
              smart_count: roomsCount,
            });
          }
        } else {
          if (enableTest) {
            fomoMsg.message = 'Only 7 rooms available';
          } else if (configlastRoomCount == 1) {
            fomoMsg.message = translate('fomoMessages.lastRoom');
          } else {
            fomoMsg.message = translate('roomCard.roomsLeftText', {
              smart_count: configlastRoomCount,
            });
          }
        }
      }
    }

    fomoMsg.rate = {};
    return fomoMsg;
  };
  // eslint-disable-next-line no-shadow
  const createRoomRateFOMOMsgOrig = () => {
    const fomoMsg = getMessageForAvailable(rooms);
    rooms.rates.forEach((rate, index) => {
      const discountFomo = getMessageForRate(rate);

      if (leadRateOnly) {
        if (
          checkLeadRate(leadRateID, rooms.id, rate.id, rate.rateOptionId) &&
          discountFomo
        ) {
          fomoMsg.rate[rate.id] = {
            option: {
              [rate.rateOptionId]: {
                message: getMessageForRate(rate),
              },
            },
          };
        }
      } else {
        if (discountFomo) {
          fomoMsg.rate[rate.id] = {
            option: {
              [rate.rateOptionId]: {
                message: getMessageForRate(rate),
              },
            },
          };
        }
      }
    });

    return fomoMsg;
  };
  if (isBanner) {
    if (featureEnableFOMO) {
      if (configFastFillingFomo)
        return enableTest
          ? 'Rooms are filling fast, book now before it’s gone'
          : translate('fomoMessages.fastFilling');
      if (configBookingDoneFomo)
        return enableTest
          ? 'Rooms are in high demand in the last hour'
          : translate('fomoMessages.highDemand');
      return '';
    }
    return '';
  }
  if (
    !rooms ||
    Object.keys(rooms).length === 0 ||
    !rooms.rates ||
    !featureEnableFOMO
  ) {
    // Handle the case when rooms is an empty object or rooms.rates is undefined
    return {}; // or any other appropriate action
  }

  if (leadRoomOnly) {
    if (isLeadRate) {
      return createRoomRateFOMOMsgOrig();
    }
  } else {
    return createRoomRateFOMOMsgOrig();
  }
  return {};
};

LowInventoryFOMOmsg.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  roomSource: PropTypes.object.isRequired,
  rooms: PropTypes.object.isRequired,
  leadRoomOnly: PropTypes.bool,
  leadRateOnly: PropTypes.bool,
  hotelID: PropTypes.string,
  hotelsPriceDrop: PropTypes.string,
  hotelsLastRoom: PropTypes.string,
  lastRoomCount: PropTypes.number,
  featureEnableFOMO: PropTypes.bool,
  enableTest: PropTypes.bool,
  isBanner: PropTypes.bool,
  bookingDoneFomo: PropTypes.string,
  fastFillingFomo: PropTypes.string,
  testLeadRate: PropTypes.bool,
  testCheckID: PropTypes.bool,
  useOnlyFeatureFlags: PropTypes.bool,
};
